import {
  Buildings,
  CalendarBlank,
  ChartLine,
  ChartBar,
  CirclesThree,
  Fire,
  Funnel,
  Gear,
  Package,
  Path,
  PlugsConnected,
  PresentationChart,
  SignOut,
  Sparkle,
  SquaresFour,
  Ticket,
  TreeStructure,
  UsersThree,
} from '@phosphor-icons/react';
import { APP_NAV } from '../../context/AppNavigationContext';

export const JOURNEY_CHILDREN = [
  { id: APP_NAV.FUNNEL, label: 'Funnel', icon: Funnel },
  { id: APP_NAV.PATHS, label: 'Paths', icon: TreeStructure },
  { id: APP_NAV.SCAN_HEATMAP, label: 'Scan heatmap', icon: Fire },
];

export const CUSTOMER_NAV_ITEMS = [
  { id: APP_NAV.OVERVIEW, label: 'Overview', icon: SquaresFour },
  { id: APP_NAV.TRENDS, label: 'Trends', icon: PresentationChart },
  { id: APP_NAV.REVENUE_MOVEMENT, label: 'Revenue movement', icon: ChartBar },
  { id: APP_NAV.PRODUCTS, label: 'Products', icon: Package },
  { id: APP_NAV.EVENTS, label: 'Events', icon: CalendarBlank },
  { id: APP_NAV.VENUES, label: 'Venues', icon: Buildings },
  {
    id: 'journeys',
    label: 'Journeys',
    icon: Path,
    children: JOURNEY_CHILDREN,
  },
  { id: APP_NAV.CUSTOMER_SEGMENTS, label: 'Segments', icon: CirclesThree },
  { id: APP_NAV.REVENUE_PREDICTION, label: 'Prediction', icon: ChartLine },
  { id: APP_NAV.CHAT, label: 'AI Assistant', icon: Sparkle },
  { id: APP_NAV.INTEGRATIONS, label: 'Integrations', icon: PlugsConnected },
  { id: APP_NAV.ACCOUNT_SETTINGS, label: 'Settings', icon: Gear },
];

export const ADMIN_NAV_ITEMS = [
  { id: APP_NAV.ACCOUNT_MANAGEMENT, label: 'Tenants', icon: UsersThree },
];

export const SIDEBAR_ACTION_ICONS = {
  signOut: SignOut,
  ticket: Ticket,
};
